module.exports = __webpack_public_path__ + "static/media/price.9964cec5.png";